import { hubApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';
import { subscriptionKeys } from '@/lib/query/keys/subscription';
import { useHubStore } from '@/lib/store/hubStore';
import { UserHub } from '@addmile/backend-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UserData {
  user: UserHub;
}

export const useDeleteUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userId: string) => {
      const token = await getAuthToken();
      const response = await hubApi.deleteUserHub(userId, withAuthHeader(token));
      if (response.status !== 204) {
        throw new Error(response.statusText || 'Failed to delete user');
      }
      return userId;
    },

    onSuccess: (userId) => {
      queryClient
        .getQueryCache()
        .findAll()
        .forEach((query) => {
          if (Array.isArray(query.queryKey) && query.queryKey[0] === 'users') {
            const data = queryClient.getQueryData(query.queryKey) as UserData;

            if (data?.user?.id === userId) {
              queryClient.removeQueries({ queryKey: query.queryKey });
            }
          }
        });

      queryClient.removeQueries({
        queryKey: subscriptionKeys.byUser(userId),
      });

      const hubStore = useHubStore.getState();
      if (hubStore.searchUserData?.id === userId) {
        useHubStore.setState({ searchUserData: undefined });
      }
    },
  });
};
